import React, {useEffect, useState} from 'react'
import { TableWrapper } from '../../../libs/react-mpk/wrapper'
import Modal from '../../../libs/react-mpk/components/Modal'
import t from 'counterpart'
import service from './SandingAset.service'
import moment from 'moment'
import { toast } from '../../../libs/react-mpk/services'
import Utils from '../../../libs/custom/Utils'
import { inject, observer } from 'mobx-react'

var _baseId = "mod-table-sanding-aset"

const SandingAsetTable = ({
  className       = '',
  showCommandbar  = true,
  history,
  match,
  sipStore,
  navigationStore
}) => {

  const [confirmDelete, setConfirmDelete] = useState(false)
  const [confirmDeleteData, setConfirmDeleteData] = useState({})

  function _closeConfirmDelete() {
    setConfirmDelete(false)
  }
  async function _submitConfirmDelete(callback) {
    var r = await service.delete(confirmDeleteData.id)
    toast.info(`Data ${confirmDeleteData.nama} telah di hapus.`); callback()
    setConfirmDelete(false)
    TableWrapper.reload(_baseId)
  }

  return (
    <>
    <TableWrapper
      baseId={_baseId}
      title='Sanding Aset'
      className={className}
      // hintMessage={t.translate('modules.table.hint.message')}
      hintIconClassName="mdi mdi-information"
      hintMore={t.translate('modules.table.hint.more')}
      defaultData={[]}
      defaultSortBy="namaAkun"
      columns={[
        {
          label: 'Nama Akun',
          searchable: true,
          key: 'nama',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.namaAkun)
        },
        {
          label: 'Nomor Akun',
          searchable: true,
          key: 'nomor',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.nomorAkun)
        },
        {
          label: 'Saldo Aktiva Tetap (Aset)',
          searchable: true,
          key: 'penyusutanFiskal',
          type: TableWrapper.dataTypes.STRING,
          render: item => (Utils.numberFormat(item.saldoAktivaTetapItem))
        },
        {
          label: 'Saldo Aktiva Tetap (Akun)',
          searchable: true,
          key: 'penyusutanKomersial',
          type: TableWrapper.dataTypes.STRING,
          render: item => (Utils.numberFormat(item.saldoAktivaTetapAkun))
        },
        {
          label: 'Nilai Hasil Penyusutan',
          searchable: true,
          key: 'penyusutanKomersial',
          type: TableWrapper.dataTypes.STRING,
          render: item => (Utils.numberFormat(item.nilaiHasilPenyandingan))
        },

      ]}
      actions={[
        // new TableWrapper.action('Add', 'mdi mdi-plus', () => history.push('/onpremise/penyusutan-periode-aset/baru'), true)
      ]}
      itemActions={[
        new TableWrapper.action('Sanding per Aset', 'mdi mdi-book-open', (item) => {
          history.push(`/onpremise/sanding-aset-peraset/${item.id}`)
        }, true),
        new TableWrapper.action('Sanding per Akun', 'mdi mdi-book-open', (item) => {
          history.push(`/onpremise/sanding-aset-perakun/${item.id}`)
        }, true),
        new TableWrapper.action('Kertas kerja sanding', 'mdi mdi-book-open', (item) => {
          history.push(`/onpremise/kertas-kerja-sanding/${item.id}`)
        }, true),
      ]}
      onFetchData={ async query => {
        if(!query) query = {}
        if(sipStore.periodeId) {
          query['periodeFiskalId.equals'] = sipStore.periodeId
          query['perusahaanId.equals'] = sipStore.companyId
        }
        return service.get(query)
      }}
      showCommandbar={showCommandbar}
      showFilterPeriod={false}
    />
    <Modal.Confirm
      // title="Hapus Data"
      visible={confirmDelete}
      onRequestClose={_closeConfirmDelete}
      onSubmit={_submitConfirmDelete}
    >Hapus data {confirmDeleteData.nama}?</Modal.Confirm>
    </>
  )
}


export default inject('sipStore', 'navigationStore')(observer(SandingAsetTable))
